$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});


// WEBPACK FOOTER //
// ./Private/JavaScript/Component/InitializeBootstrapComponents.js